import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysConvert',
})
export class DaysConvertPipe implements PipeTransform {
  days: any;
  transform(value: number): any {
    var years = Math.floor(value / 365);
    var months = Math.floor((value % 365) / 30);
    var week = Math.floor(((value % 365) % 30) / 7);
    var days = Math.floor(((value % 365) % 30) % 7);
    var yearsDisplay =
      years > 0 ? years + (years == 1 ? ' year, ' : ' years, ') : '';
    var monthsDisplay =
      months > 0 ? months + (months == 1 ? ' month, ' : ' months, ') : '';
    var daysDisplay = days > 0 ? days + (days == 1 ? ' day' : ' days') : '';
    var weekDisplay = week > 0 ? week + (week == 1 ? ' week, ' : ' weeks, ') : '';
    let text = yearsDisplay + monthsDisplay + weekDisplay + daysDisplay;
    text = text.replace(/,\s*$/, "");
    return text
  }
}
